import React, { useContext } from "react";
import conventionTrackerContext from "../../../../context/conventionTrackerContext";
import "./index.scss";

const MIN_TICKER_CHAR_LENGTH = 600;

/**
 * @desc Displays an announcement ticker.
 */
export const Ticker = () => {
  // CONSTANTS ----------------------------------------------------------------

  const { convention } = useContext(conventionTrackerContext);
  const { announcement = "" } = convention;

  // COMPONENT ----------------------------------------------------------------

  const renderTickerContent = () => {
    const repeatTimes = Math.ceil(
      MIN_TICKER_CHAR_LENGTH / (announcement.length + 3)
    );
    const displayStr = announcement
      ? Array(repeatTimes).fill(announcement).join(" • ")
      : "";
    const props = {
      className: "ticker-animation",
    };
    return (
      <div className={"flex announcement"}>
        <div {...props}>{displayStr}</div>
      </div>
    );
  };

  if (!announcement.length) return null;

  const props = {
    className: "flex ticker",
  };

  return <div {...props}>{renderTickerContent()}</div>;
};
